import React, { Component } from "react";
import {
    func,
    number,
    string,
    object
} from 'prop-types';
import html2pdf from 'html2pdf.js';
import Currency from 'react-currency-formatter';
import bowser from 'bowser';
import filterZeroAccounts from '../../../../utils/filterZeroAccounts';


class PaymentReceiptV2 extends Component {

  state = {
    enablePDFButton: true
  }

componentWillMount(){

  this.checkForRecieptInfoStorage()


  //check if browser is microsoft Internet Explorer
   if (bowser.msie) {
     this.setState({
       enablePDFButton: false
     })
   }

}

checkForRecieptInfoStorage = () => {
  if(localStorage.getItem("recieptInfo") === null && !this.props.receiptInfo){
      this.props.history.push("/");
  } else {
    this.retrieveReceiptInfo()

  }
}

retrieveReceiptInfo = () => {
  try{
    const {
      accounts, currAccount, date, time, account_number, totalAmount, transactionID, selectedPayMethod
    } = JSON.parse(localStorage.getItem("recieptInfo"));
  
    return {
      accounts, currAccount, date, time, account_number, totalAmount, transactionID,selectedPayMethod
    }

  } catch (err){
    const {
      accounts, currAccount, date, time, account_number, totalAmount, transactionID, selectedPayMethod
    } = this.props.receiptInfo;
  
    return {
      accounts, currAccount, date, time, account_number, totalAmount, transactionID,selectedPayMethod
    }
  }

  
}

 printDocument = () => {

   let el = document.getElementById("receipt");

   let opts = {
      margin:       1,
      filename:     'payment-receipt.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas:  { dpi: 192, letterRendering: true, height: 700, width: 600},
      jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf(el, opts);

 }


 renderAccounts = accounts => {

     //first filter the accounts with zero balances;
     let filteredAccounts = filterZeroAccounts(accounts);
     let elArray = [];

     for (let key in filteredAccounts) {
       if (filteredAccounts.hasOwnProperty(key)) {
          const productcode=accounts[key].product_code;
          let value=key+"";
          if(productcode==="RSCIA") value+=" RSCIA";
         let el =
           (<div
             key={key}
             className="item">
              
              <div className="name">{value}</div>
              <div className="amount">
                <Currency
                  quantity={filteredAccounts[key]}
                  pattern="!#,##0.00"
                />
              </div>
            </div>);
         elArray.push(el)
       }
     }
     return elArray;
 }

  render(){

    let {
      currAccount,
      totalAmount,
      transactionID,
      accounts,
      date,
      time,
      account_number,
      selectedPayMethod
    } = this.retrieveReceiptInfo();

      let { enablePDFButton } = this.state;

      let accountListAndAmount = this.renderAccounts(accounts);

      let editedCurrency = (
        <Currency
          quantity={totalAmount}
          pattern="!#,##0.00"
        />

      )
    return (
			<div className="com-receiptpage" id="receipt">
				<div className="dx-col">
					<div className="printable-area">
						<div className="header-area">
							<div className="header-logo">
                                <img src="/media/icons/PCS-Logo-RGB-2COL-BLUE-GOLD.png" alt="AIG Brand" width="80" height="35" />
							</div>
							<div className="header-info">
								<div className="pcg-text">Private Client Select</div>
								<div className="account-name" style={{display:"none"}}>Account: <strong>{currAccount}</strong></div>
								<div className="confirmation-number">Confirmation number: <strong>{transactionID}</strong></div>

							</div>
						</div>
						<div className="content-area">
							<div className="accounts-intro">
                {/* A payment of 	<strong>{editedCurrency}</strong>was sent at {time} on {date} */}
              <p>A payment of <strong>{editedCurrency}</strong> from
              {(selectedPayMethod[0] === 'card')   ? ' card ' : selectedPayMethod[1]==='checking' ? ' checking account ' : ' savings account ' }
               ending in <strong>{account_number}</strong> was submitted at <span style={{display:'inline-block'}}>{time} on {date}.</span></p>
			        <p>An email confirmation has been sent.</p>
							</div>
							<div className="accounts-list">
			          <div className="header">
			            <div className="billing-amt-header">Billing Account</div>
			            <div className="amount-sent-header">Amount</div>
			          </div>
								{accountListAndAmount}
								<div className="item total">
									<div className="amount">
										{editedCurrency}
									</div>
								</div>
							</div>
							<div className="additional-text">
								Please allow 1-3 business days for processing.<br />
							  Payments on accounts with lapsed or cancelled policies do not guarantee reinstatement.
							</div>
						</div>
					</div>
          {  enablePDFButton ?
            <div className="buttons-area" data-html2canvas-ignore>
              <button className="primary secondary" onClick={this.printDocument} style={{'maxWidth':'15em'}}>
                Save as PDF
              </button>
            </div> :
            <div />
          }

				</div>
			</div>
    );
  }

}

PaymentReceiptV2.propTypes = {
  printDocument: func,
  currAccount: string,
  totalAmount: number,
  transactionID: string,
  accounts: object,
  date: string,
  time: string,
}

export default PaymentReceiptV2;



// WEBPACK FOOTER //
// ./src/components/atomic/pages/Receipt/PaymentReceipt-V2.js